// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  font-family: "Roboto-Medium";
}

.px-16px {
  padding-left: 16px;
  padding-right: 16px;
}

.py-16px {
  padding-top: 16px;
  padding-bottom: 16px;
}

.p-16px {
  padding: 16px;
}

.pr-16px {
  padding-right: 16px !important;
  padding-inline-end: 16px !important;
}

.pl-16px {
  padding-left: 16px !important;
  padding-inline-start: 16px !important;
}

.pb-16px {
  padding-bottom: 16px;
}

.pt-16px {
  padding-top: 16px;
  --padding-top: 16px;
}

.m-0 {
  margin: 0 !important;
}

.p-0 {
  padding: 0 !important;
}

.d-f-a-c {
  align-items: center;
  display: flex;
}

.three-dots {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  height: 100%;
  white-space: nowrap;
}

.payment-success-wrapper {
  display: flex;
  flex-direction: column;
}
.payment-success-wrapper .text {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  height: 40vh;
}
.payment-success-wrapper .text h2 {
  margin-top: 32px;
}

.contact-us {
  font-size: 12px;
  margin-top: 8px;
  font-family: "Roboto-Medium";
  color: var(--vl-black-font);
  display: flex;
  justify-content: center;
}
.contact-us span {
  padding-left: 8px;
  color: var(--vl-red);
}

.check-box {
  font-size: 18px !important;
  font-family: "Roboto-Medium";
}

.custom-btn-block .col-12 {
  max-width: 350px;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_vl-variables.scss","webpack://./src/app/modules/payment/components/payment-successfull/payment-successful.component.scss"],"names":[],"mappings":"AAgBA;EACE,4BAXc;ACJhB;;ADmBA;EACE,kBAZe;EAaf,mBAbe;ACHjB;;ADmBA;EACE,iBAjBe;EAkBf,oBAlBe;ACEjB;;ADmBA;EACE,aAtBe;ACMjB;;ADmBA;EACE,8BAAA;EACA,mCAAA;AChBF;;ADmBA;EACE,6BAAA;EACA,qCAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,iBAAA;EACA,mBAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,qBAAA;AChBF;;ADmBA;EACE,mBAAA;EACA,aAAA;AChBF;;ADmBA;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AChBF;;AAvDA;EACE,aAAA;EACA,sBAAA;AA0DF;AAxDE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;AA0DJ;AAxDI;EACE,gBAAA;AA0DN;;AArDA;EACE,eAAA;EACA,eAAA;EACA,4BDjBc;ECkBd,2BAAA;EACA,aAAA;EACA,uBAAA;AAwDF;AAvDE;EACE,iBAAA;EACA,oBAAA;AAyDJ;;AArDA;EACE,0BAAA;EACA,4BD7Bc;ACqFhB;;AApDE;EACE,gBAAA;AAuDJ","sourcesContent":["$red: #EB0000;\n$black: #262627;\n\n$font-path: \"~roboto-fontface/fonts/roboto/\";\n$font-format: 'woff';\n$roboto-bold: \"Roboto-Bold\";\n$roboto-medium: \"Roboto-Medium\";\n$roboto-light: \"Roboto-Light\";\n$roboto-regular: \"Roboto-Regular\";\n\n$global-padding: 16px;\n$global-padding-with-fixed-button: 108px;\n$toolbar-height: 70px;\n$modal-height: 425px;\n$edit-phone-email-modal-height: 325px;\n\nion-button {\n  font-family: $roboto-medium;\n}\n\n\n.px-16px {\n  padding-left: $global-padding;\n  padding-right: $global-padding;\n}\n\n.py-16px {\n  padding-top: $global-padding;\n  padding-bottom: $global-padding;\n}\n\n.p-16px {\n  padding: $global-padding;\n}\n\n.pr-16px {\n  padding-right: $global-padding !important;\n  padding-inline-end: $global-padding !important;\n}\n\n.pl-16px {\n  padding-left: $global-padding !important;\n  padding-inline-start: $global-padding !important;\n}\n\n.pb-16px {\n  padding-bottom: 16px;\n}\n\n.pt-16px {\n  padding-top: 16px;\n  --padding-top: 16px;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.d-f-a-c {\n  align-items: center;\n  display: flex;\n}\n\n.three-dots {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  white-space: nowrap;\n}\n","@use \"/src/assets/scss/vl-variables\" as *;\n\n.payment-success-wrapper {\n  display: flex;\n  flex-direction: column;\n\n  .text {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    flex-direction: column;\n    height: 40vh;\n\n    h2 {\n      margin-top: 32px;\n    }\n  }\n}\n\n.contact-us {\n  font-size: 12px;\n  margin-top: 8px;\n  font-family: $roboto-medium;\n  color: var(--vl-black-font);\n  display: flex;\n  justify-content: center;\n  span {\n    padding-left: 8px;\n    color: var(--vl-red);\n  }\n}\n\n.check-box {\n  font-size: 18px !important;\n  font-family: $roboto-medium;\n}\n\n.custom-btn-block {\n  .col-12 {\n    max-width: 350px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
